import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
} from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';
import { StatusType } from '../../constants/status.type';
import { StatusTextType } from '../../constants/status-text.type';
import { HearingMethodType } from '../../constants/hearing-method.type';
import { MatTableDataSource } from '@angular/material/table';
import { NgxFileDropComponent } from 'ngx-file-drop';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { DocumentUploadModel } from '../../models/document-upload.model';
import { formatBytes } from '../../utils/format-bytes';
import { DocumentUploadStatus } from '../../constants/document-upload-status.type';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MaterialTypeGroup } from '../../models/material-type-group.model';
import { MatSelectChange } from '@angular/material/select';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
@Component({
  selector: 'jsg-hearing-associate-materials-upload-view',
  templateUrl: './hearing-associate-materials-upload-view.component.html',
  styleUrls: ['./hearing-associate-materials-upload-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HearingAssociateMaterialsUploadViewComponent implements OnInit {
  readonly formPath = 'lawyer.associateMaterials.forms.associatedMaterialType';

  @ViewChild(NgxFileDropComponent, { static: false })
  ngxFileDropComponent: NgxFileDropComponent;
  private data: DocumentUploadModel[];
  get tableData(): DocumentUploadModel[] {
    return this.data;
  }
  @Input()
  set tableData(value: DocumentUploadModel[]) {
    this.data = value;
    this.dataSource = new MatTableDataSource(value);
  }

  @Input() associateMaterialTypeGroup: MaterialTypeGroup[];
  @Input() associateMaterialsUploadInfoText: string;
  @Input() form: FormGroup;

  @Output() associateMaterials = new EventEmitter();
  @Output() selectUploadTab = new EventEmitter();
  @Output() cancelUpload = new EventEmitter<{
    fileIndex: number;
    docUploadsFormArray: FormArray;
  }>();
  @Output() deleteUpload = new EventEmitter<{
    fileIndex: number;
    docUploadsFormArray: FormArray;
  }>();
  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();
  @Output() filesSelected = new EventEmitter<NgxFileDropEntry[]>();

  public maxDate = new Date();

  displayedColumns: string[] = [
    'fileName',
    'size',
    'materialType',
    'filedDate',
    'action',
  ];
  dataSource = new MatTableDataSource<DocumentUploadModel>();
  a: string[] = ['message-row'];
  public FlexLayoutType = FlexLayoutType;
  public StatusType = StatusType;
  public DocumentUploadStatus = DocumentUploadStatus;
  public StatusTextType = StatusTextType;
  public HearingMethodType = HearingMethodType;
  public formatBytes = formatBytes;

  public showMaxFileCountError: boolean = false;

  constructor(private fb: FormBuilder) {
    this.showMaxFileCountError = false;
  }

  ngOnInit() {
    // this.form = this.fb.group({
    //   associateDocumentUploads: this.fb.array([]),
    // });
  }

  get associateDocumentUploads(): FormArray {
    return this.form.get('associateDocumentUploads') as FormArray;
  }

  private createSingleItem = (): FormGroup => {
    let formGroup = this.fb.group({
      materialTypeId: ['', Validators.required],
      filedDate: [''],
      documentId: [{ value: '', disabled: true }, Validators.required],
    });
    return formGroup;
  };

  public onAssociateMaterials = () => {
    this.associateMaterials.emit();
  };

  public onSelectUploadTab = () => {
    this.selectUploadTab.emit();
  };

  public onChooseFileClick = () => {
    this.ngxFileDropComponent.openFileSelector();
  };

  public fileDropped = (files: NgxFileDropEntry[]) => {
    if (files.length > 10) {
      this.showMaxFileCountError = true;
    } else {
      this.showMaxFileCountError = false;
      files.forEach((file) => {
        this.associateDocumentUploads.push(this.createSingleItem());
      });
      this.filesSelected.emit(files);
    }
  };

  public onErrorPanelClose = () => {
    this.showMaxFileCountError = false;
  };

  public onCancelUploadClick = (fileIndex: number) => {
    const args = {
      fileIndex: fileIndex,
      docUploadsFormArray: this.associateDocumentUploads,
    };
    this.cancelUpload.emit(args);
  };

  public onDeleteUploadClick = (fileIndex: number) => {
    const args = {
      fileIndex: fileIndex,
      docUploadsFormArray: this.associateDocumentUploads,
    };
    this.deleteUpload.emit(args);
  };

  public onOpenFile = (docToOpen: DocumentUploadModel) => {
    this.openFile.emit(docToOpen.document);
  };

  public getMaterialTypePlaceholder = (document: DocumentUploadModel) => {
    if (document.uploadStatus == DocumentUploadStatus.Uploaded) {
      return 'Select';
    }
    return '';
  };

  public onMaterialTypeChange(
    materialTypeChange: MatSelectChange,
    index: number
  ) {
    const filedDateControl: AbstractControl = this.associateDocumentUploads.controls[
      index
    ].get('filedDate');

    if (
      this.associateMaterialTypeGroup
        .find((x) => x.materialTypeGroupName == 'Others')
        ?.types.some((x) => x.id == materialTypeChange.value)
    ) {
      filedDateControl.setValidators(null);
    } else {
      filedDateControl.setValidators([Validators.required]);
    }

    filedDateControl.updateValueAndValidity();
  }

  public getFiledDateInputDisabled = (
    args: DocumentUploadModel,
    index: number
  ) => {
    const materialTypeControl: AbstractControl = this.associateDocumentUploads.controls[
      index
    ].get('materialTypeId');
    const filedDateControl: AbstractControl = this.associateDocumentUploads.controls[
      index
    ].get('filedDate');

    if (
      this.associateMaterialTypeGroup
        .find((x) => x.materialTypeGroupName == 'Others')
        ?.types.some((x) => x.id == materialTypeControl?.value) ||
      args?.uploadStatus != DocumentUploadStatus.Uploaded
    ) {
      filedDateControl?.setValue(null);
      return true;
    } else {
      return false;
    }
  };
}
